import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Icon } from 'bv-components';

import MarketFilter from 'InPlayOverview/components/market_filter/market_filter';
import CompetitionContext from 'InPlayOverview/services/competition_context';
import MarketfilterContext from 'InPlayOverview/services/marketfilter_context';
import Pager from 'InPlayOverview/components/coupons/pager';
import Competition from './competition';

const CompetitionsComponent = ({
  sport, widget, showMarketFilter, showSportHeader,
}) => {
  const competitions = (sport && sport.comp) || [];

  if (!competitions.length) {
    return null;
  }

  const { selectedMarketType } = sport;
  const { selectedPeriod } = sport;
  // change _ to - and remove tailing numbers (think of template_b1)
  const couponClass = selectedMarketType.couponName.replace('_', '-').replace(/\d$/, '');

  const marketFilterContextValue = useMemo(() => ({
    marketType: selectedMarketType,
    period: selectedPeriod,
    sport,
  }), [sport]);

  return (
    <div className={!widget && 'bvs-card inplay'}>
      <div className="inply-coupons-wrapper">
        { showMarketFilter && (
        <MarketfilterContext.Provider
          value={marketFilterContextValue}
        >
          <MarketFilter marketTypes={sport.marketTypes} />
        </MarketfilterContext.Provider>
        )}
        <div className={`inply-coupon inply-${couponClass}-coupon`}>
          { showSportHeader && (
          <div className="inply-coupon-sport-name">
            <Icon id={`sport-${sport.id}`} type="inplay-sport" />
            {sport.desc}
          </div>
          )}
          {
              competitions.map((competition) => (
                <CompetitionContext.Provider
                  // eslint-disable-next-line react/jsx-no-constructed-context-values
                  value={{
                    marketType: selectedMarketType,
                    period: selectedPeriod,
                    sport,
                    competition,
                  }}
                >
                  <Competition
                    key={competition.id}
                    couponName={selectedMarketType.couponName}
                    headers={selectedMarketType.headers}
                    competition={competition}
                  />
                </CompetitionContext.Provider>
              ))
            }
          {
              !widget
              && sport.numberOfEvents > sport.eventsShown
              && (
              <Pager
                sportId={sport.id}
                eventIncrement={sport.eic}
                numberOfEvents={sport.numberOfEvents}
                eventsShown={sport.eventsShown}
              />
              )
            }
        </div>
      </div>
    </div>
  );
};

CompetitionsComponent.propTypes = {
  sport: PropTypes.instanceOf(Object).isRequired,
  widget: PropTypes.bool.isRequired,
  showSportHeader: PropTypes.bool.isRequired,
  showMarketFilter: PropTypes.bool,
};

CompetitionsComponent.defaultProps = {
  showMarketFilter: false,
};

const mapStateToProps = (state) => ({
  locale: state.inplay.locale,
  fetchingSport: state.inplay.fetchingSport,
  treeType: state.inplay.treeType,
  widget: state.inplay.widget,
  sports: state.inplay.sports,
});

export default connect(mapStateToProps)(CompetitionsComponent);
